<template>
    <ion-page>
        <ion-content>
            <ion-grid>
                <ion-row class="content-row" align-items-center>
                    <ion-col size-xs="12" offset-xs="0" size-sm="8" offset-sm="2" size-md="6" offset-md="3" size-lg="4" offset-lg="4" text-center>
                        <ion-img class="logo" :src="require('@/assets/logo_full_small.png')"></ion-img>
                        <transition name="collapse-fade" mode="out-in">
                            <component :is="view" @confirm="onConfirm" :parentError="errorMsg"></component>
                        </transition>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-content>
    </ion-page>
</template>

<script>
import axios from 'axios';
import ConfirmForm from '@/components/ConfirmForm.vue';
import LoggingIn from '@/components/LoggingIn.vue';

export default {
    name: 'Confirm',
    components: {
        ConfirmForm,
        LoggingIn
    },
    data() {
        return {
            code: this.$route.params.code,
            uid: this.$route.params.uid,
            passwordPattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!\-_.:;?[\]{}()/&%$#@=\\*+])[A-Za-z\d!\-_.:;?[\]{}()/&%$#@=\\*+]{8,}$/,
            view: ConfirmForm,
            savingScreen: false,
            errorMsg: '',
            saving: false,
            timeout: 10000,
        };
    },
    methods: {
        onConfirm: function(pass, validPassword) {
            this.$logger.debug('onConfirm');
            //this.isPasswordValid();
            if (validPassword) {
                this.saving = true;
                axios.post(process.env.VUE_APP_API_VERIFY_BASE + '/confirm_user', { code: this.code, uid: this.uid, pass} ).then(response => {
                    this.view = LoggingIn;
                    this.saving = false;
                    const email = atob(response.data.login);
                    this.$Amplify.Auth.signIn(
                        email, // Required, the username
                        pass // Optional, the password
                    ).then(user => {
                        this.$logger.debug(user);
                        this.$AmplifyEventBus.$emit('authState', 'signedIn')
                        this.$store.setSignedIn(true);
                        this.$store.setUser(user);
                        this.$router.push('/');
                    }).catch(err => {
                        this.saving = false;
                        this.errorMsg = this.$t('screens.confirm.something-wrong');
                        this.$logger.error(err);
                    });
                }).catch(err => {
                    // error on save password
                    this.saving = false;
                    this.errorMsg = this.$t('screens.confirm.something-wrong');
                    this.$logger.error(err);
                });
            }
        }
    },
    beforeDestroy() {
        //the watcher gets destroyed too fast so we need to dismiss the loading here just in case
        if (this.savingScreen) {
            this.savingScreen.dismiss();
        }
    },
    watch: {
        saving: function(val) {
            if (val) {
                this.$ionic.loadingController.create({
                    message: this.$t('screens.confirm.saving'),
                    duration: this.timeout,
                }).then(l => {
                    this.savingScreen = l;
                    l.present();
                    l.onDidDismiss().then(() => {
                        this.savingScreen = false;
                    });
                });
            } else {
                this.savingScreen.dismiss();
            }
        }
    }
};
</script>

<style scoped>
    ion-content {
        --background: url('~@/assets/bg/bg4.jpg') no-repeat center center / cover;
    }

    ion-grid {
        height: 100%;
        font-family: 'Nunito', sans-serif;
        padding: 1em;
    }

    .content-row ion-input {
        margin-left: .5em;
    }

    .content-row ion-item {
        --background: rgba(255,255,255,.6);
        width: 98%;
        margin-left: 1%;
        margin-bottom: .5em;
    }

    .content-row ion-button {
        margin-top: 1em;
    }

    .content-row ion-card-subtitle {
        color: #333;
        font-size: 1.4em;
    }

    .content-row ion-card-header {
        --background: none;
        font-weight: bold;
    }

    .content-row ion-card {
        --background: rgba(255,255,255,.8);
        font-family: 'Nunito', sans-serif;
    }

    .content-row ion-card-title {
        --color: #333;
        font-size: 2.5em;
    }

    .content-row ion-card-subtitle {
        padding: 1em 0 0 .3em;
    }

    .content-row ion-col {
        padding: 0;
    }

    .content-row ion-label {
        display: block;
        margin-bottom: .5em;
    }
</style>